import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout only — list/new/detail are child routes that render via Outlet. */
export const Route = createFileRoute("/partners")({
  component: PartnersLayout,
});

function PartnersLayout() {
  return <Outlet />;
}
